
let USER_PERMISSIONS = new Set<string>();

export const initUserPermissions = (permissions: string[]): void => {
    USER_PERMISSIONS = new Set(permissions);
};

export const hasPermission = (permission: string): boolean => {
    console.log('USER_PERMISSIONS:', USER_PERMISSIONS);
    console.log('hasPermission:', permission, USER_PERMISSIONS.has(permission));
    return USER_PERMISSIONS.has(permission);
};

